{
  "v": "5.0.1",
  "fr": 30,
  "ip": 0,
  "op": 105,
  "w": 375,
  "h": 812,
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ind": 3,
      "nm": "Full Icon Anim-Scaled",
      "ks": {
        "p": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [124.948, 315.369, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [57.962, 218.333, 0]
            },
            {
              "t": 14,
              "s": [57.962, 218.333, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.55], "y": [0.95] },
              "o": { "x": [0.445], "y": [0.05] },
              "e": [28.832, 176.125, 0]
            },
            {
              "t": 25,
              "s": [28.832, 176.125, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [54.069, 212.692, 0]
            },
            {
              "t": 32,
              "s": [54.069, 212.692, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [15.072, 255.829, 0]
            },
            {
              "t": 40,
              "s": [15.072, 255.829, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [15.072, 255.829, 0]
            },
            {
              "t": 42,
              "s": [15.072, 255.829, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [15.072, 255.829, 0]
            },
            {
              "t": 63,
              "s": [15.072, 255.829, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [15.072, 255.829, 0]
            },
            {
              "t": 72,
              "s": [15.072, 255.829, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [71.42, 322.823, 0]
            },
            { "t": 76, "s": [71.42, 322.823, 0] }
          ]
        },
        "a": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [-16.47, -23.864, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [-34.11, -49.415, 0]
            },
            {
              "t": 14,
              "s": [-34.11, -49.415, 0],
              "i": { "x": [0.55], "y": [0.95] },
              "o": { "x": [0.445], "y": [0.05] },
              "e": [-41.78, -60.53, 0]
            },
            {
              "t": 25,
              "s": [-41.78, -60.53, 0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [-20.389, -29.536, 0]
            },
            { "t": 40, "s": [-20.389, -29.536, 0] }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 14,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 25,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 33,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 40,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 63,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [253.18, 253.18, 100]
            },
            {
              "t": 72,
              "s": [253.18, 253.18, 100],
              "i": { "x": [0.745], "y": [0.715] },
              "o": { "x": [0], "y": [0] },
              "e": [100, 100, 100]
            },
            { "t": 76, "s": [100, 100, 100] }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "t": 0,
              "s": [100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [100]
            },
            {
              "t": 8,
              "s": [100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [100]
            },
            {
              "t": 63,
              "s": [100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [50]
            },
            {
              "t": 72,
              "s": [50],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [0]
            },
            { "t": 76, "s": [0] }
          ]
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 105,
      "st": 0,
      "bm": 0,
      "sr": 1,
      "ty": 4,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0.04, -5.16],
                        [4.934, 0.068],
                        [0.041, 4.792],
                        [-5.016, 0.01]
                      ],
                      "o": [
                        [5.098, -0.01],
                        [-0.039, 5.08],
                        [-4.708, -0.066],
                        [-0.043, -5.043],
                        [0, 0]
                      ],
                      "v": [
                        [24.294, 33.443],
                        [33.014, 42.321],
                        [24.183, 51.22],
                        [15.521, 42.358],
                        [24.294, 33.443]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 1,
                    "k": [
                      {
                        "t": 2.3,
                        "s": [0.459, 0.98, 0.831, 1],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0.459, 0.98, 0.831, 1]
                      },
                      { "t": 7.7, "s": [0.459, 0.98, 0.831, 1] }
                    ]
                  },
                  "hd": false,
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 2.3,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 7.7, "s": [100] }
                    ]
                  },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 2.3,
                        "s": [4.206, 17.966],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [3.278, 19.161]
                      },
                      {
                        "t": 4.5,
                        "s": [3.278, 19.161],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [5.143, 16.887]
                      },
                      {
                        "t": 7.7,
                        "s": [5.143, 16.887],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [9.529, 10.74]
                      },
                      {
                        "t": 11,
                        "s": [9.529, 10.74],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [9.687, 10.068]
                      },
                      {
                        "t": 14.2,
                        "s": [9.687, 10.068],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [9.524, 10.745]
                      },
                      { "t": 17.5, "s": [9.524, 10.745] }
                    ]
                  },
                  "a": {
                    "a": 1,
                    "k": [
                      {
                        "t": 7.7,
                        "s": [24.268, 42.332],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [24.268, 42.332]
                      },
                      { "t": 11, "s": [24.268, 42.332] }
                    ]
                  },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "t": 2.3,
                        "s": [10, 10.009],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [39.3, 39.3]
                      },
                      { "t": 7.7, "s": [39.3, 39.3] }
                    ]
                  },
                  "r": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "circle-2",
              "ln": "circle-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "d": 1,
                      "ty": "rc",
                      "s": {
                        "a": 1,
                        "k": [
                          {
                            "t": 0,
                            "s": [43.983, 34.773],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [43.983, 34.773]
                          },
                          { "t": 6.2, "s": [43.983, 34.773] }
                        ]
                      },
                      "p": {
                        "a": 1,
                        "k": [
                          {
                            "t": 0,
                            "s": [21.991, 17.386],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [21.991, 17.386]
                          },
                          { "t": 6.2, "s": [21.991, 17.386] }
                        ]
                      },
                      "r": { "a": 0, "k": 0 }
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.071, 0.122, 0.227, 1] },
                      "hd": false,
                      "o": { "a": 0, "k": 100 },
                      "r": 1
                    },
                    {
                      "ty": "tr",
                      "p": {
                        "a": 1,
                        "k": [
                          {
                            "t": 0,
                            "s": [10.063, 3.659],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [15.657, -2.22]
                          },
                          {
                            "t": 6.2,
                            "s": [15.657, -2.22],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [12.713, -9.449]
                          },
                          {
                            "t": 8.5,
                            "s": [12.713, -9.449],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [4.731, -12.018]
                          },
                          {
                            "t": 10.8,
                            "s": [4.731, -12.018],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-8.943, -8.505]
                          },
                          {
                            "t": 12.3,
                            "s": [-8.943, -8.505],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-19.104, 9.062]
                          },
                          {
                            "t": 14.6,
                            "s": [-19.104, 9.062],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-14.926, 28.433]
                          },
                          { "t": 16.1, "s": [-14.926, 28.433] }
                        ]
                      },
                      "a": { "a": 0, "k": [20.206, 16.066] },
                      "s": { "a": 0, "k": [100, 100] },
                      "r": {
                        "a": 1,
                        "k": [
                          {
                            "t": 6.2,
                            "s": [34],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-16]
                          },
                          {
                            "t": 8.5,
                            "s": [-16],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-37]
                          },
                          {
                            "t": 10.8,
                            "s": [-37],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-88]
                          },
                          {
                            "t": 12.3,
                            "s": [-88],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-138]
                          },
                          {
                            "t": 14.6,
                            "s": [-138],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [-180]
                          },
                          { "t": 16.1, "s": [-180] }
                        ]
                      },
                      "o": {
                        "a": 1,
                        "k": [
                          {
                            "t": 34.6,
                            "s": [100],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [0]
                          },
                          { "t": 35.4, "s": [0] }
                        ]
                      },
                      "sk": { "a": 0, "k": 0 },
                      "sa": { "a": 0, "k": 0 }
                    }
                  ],
                  "nm": "Fake MASK 1-2",
                  "ln": "Fake-MASK-1-2",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "sh",
                      "d": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [8.063, -10.503],
                            [1.034, -5.011],
                            [0, 0],
                            [-0.15, 0.335],
                            [-0.22, 0.346],
                            [-4.288, 0],
                            [-1.48, -4.894],
                            [0.801, -2.607],
                            [0.004, -0.009],
                            [0.674, -0.954],
                            [2.034, -3.044],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-1.193, 1.693],
                            [10.632, 7.795]
                          ],
                          "o": [
                            [-10.911, -8],
                            [-1.873, 2.439],
                            [0, 0],
                            [0.12, -0.351],
                            [0.202, -0.481],
                            [2.062, -3.478],
                            [5.302, 0],
                            [0.761, 2.411],
                            [-0.036, 0.119],
                            [-0.391, 1.005],
                            [-1.388, 1.964],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [1.196, -1.69],
                            [7.738, -10.982],
                            [0, 0]
                          ],
                          "v": [
                            [38.545, 22.978],
                            [4.845, 27.81],
                            [0, 38.414],
                            [13.098, 38.414],
                            [13.544, 37.36],
                            [14.166, 36.163],
                            [24.268, 30.358],
                            [35.533, 38.809],
                            [35.341, 46.436],
                            [35.229, 46.735],
                            [33.637, 49.684],
                            [27.988, 57.994],
                            [17.76, 72.734],
                            [28.22, 79.999],
                            [40.542, 62.242],
                            [44.129, 57.168],
                            [38.545, 22.978]
                          ],
                          "c": true
                        },
                        "hd": false
                      }
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.459, 0.98, 0.831, 1] },
                      "hd": false,
                      "o": { "a": 0, "k": 100 },
                      "r": 1
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [9.536, 13.397] },
                      "a": { "a": 0, "k": [24.286, 49.098] },
                      "s": { "a": 0, "k": [39.265, 39.265] },
                      "r": { "a": 0, "k": 0 },
                      "o": { "a": 0, "k": 100 },
                      "sk": { "a": 0, "k": 0 },
                      "sa": { "a": 0, "k": 0 }
                    }
                  ],
                  "nm": "swoosh-2",
                  "ln": "swoosh-2",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "sh",
                      "d": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-0.784, -5.872],
                            [6.166, -5.9],
                            [13.266, 0.153],
                            [5.433, 8.037],
                            [-0.734, 8.315]
                          ],
                          "c": true
                        },
                        "hd": false
                      }
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.071, 0.122, 0.227, 1] },
                      "hd": false,
                      "o": { "a": 0, "k": 100 },
                      "r": 1
                    },
                    {
                      "ty": "tr",
                      "p": {
                        "a": 1,
                        "k": [
                          {
                            "t": 0,
                            "s": [11.731, 12.931],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [11.731, 12.931]
                          },
                          { "t": 77.7, "s": [11.731, 12.931] }
                        ]
                      },
                      "a": { "a": 0, "k": [6.997, 3.131] },
                      "s": { "a": 0, "k": [100, 100] },
                      "r": { "a": 0, "k": 0 },
                      "o": {
                        "a": 1,
                        "k": [
                          {
                            "t": 41.5,
                            "s": [100],
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "e": [0]
                          },
                          { "t": 42.3, "s": [0] }
                        ]
                      },
                      "sk": { "a": 0, "k": 0 },
                      "sa": { "a": 0, "k": 0 }
                    }
                  ],
                  "nm": "bg blocker-2",
                  "ln": "bg-blocker-2",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [10.183, 12.765] },
                  "a": { "a": 0, "k": [10.183, 12.765] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "t": 0,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      { "t": 28.2, "s": [0] }
                    ]
                  },
                  "o": { "a": 0, "k": 100 },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "Swoosh Symbol-2",
              "ln": "Swoosh-Symbol-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [1], "y": [1] },
                        "o": { "x": [0.42], "y": [0] },
                        "t": 13.6,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [13.104, 28.269],
                              [0.021, 28.269],
                              [0.021, 28.269],
                              [13.104, 28.269],
                              [13.104, 28.269]
                            ],
                            "c": true
                          }
                        ],
                        "e": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [13.104, 1.146],
                              [0.021, 1.146],
                              [0.021, 38.405],
                              [13.104, 38.405],
                              [13.104, 1.146]
                            ],
                            "c": true
                          }
                        ]
                      },
                      { "t": 23.6 }
                    ],
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.157, 0.396, 0.533, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 13.6,
                        "s": [0.01, -1.925],
                        "i": { "x": [1], "y": [1] },
                        "o": { "x": [0.42], "y": [0] },
                        "e": [0.01, -5.925]
                      },
                      { "t": 23.6, "s": [0.01, -5.925] }
                    ]
                  },
                  "a": { "a": 0, "k": [0, 0] },
                  "s": { "a": 0, "k": [39.265, 39.265] },
                  "r": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "stem-2",
              "ln": "stem-2",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [10.183, 16.74],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [16.587, 26.516]
                  },
                  {
                    "t": 14,
                    "s": [16.587, 26.516],
                    "i": { "x": [0.55], "y": [0.95] },
                    "o": { "x": [0.445], "y": [0.05] },
                    "e": [21.288, 33.691]
                  },
                  {
                    "t": 25,
                    "s": [21.288, 33.691],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [21.29, 33.69]
                  },
                  {
                    "t": 32,
                    "s": [21.29, 33.69],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [8.998, 17.309]
                  },
                  {
                    "t": 40,
                    "s": [8.998, 17.309],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [8.671, 16.829]
                  },
                  {
                    "t": 63,
                    "s": [8.671, 16.829],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [8.549, 16.648]
                  },
                  { "t": 76, "s": [8.549, 16.648] }
                ]
              },
              "a": { "a": 0, "k": [10.183, 12.765] },
              "s": {
                "a": 1,
                "k": [
                  {
                    "t": 0,
                    "s": [100, 100],
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "e": [170, 170]
                  },
                  {
                    "t": 14,
                    "s": [170, 170],
                    "i": { "x": [0.55], "y": [0.95] },
                    "o": { "x": [0.445], "y": [0.05] },
                    "e": [200, 200]
                  },
                  {
                    "t": 25,
                    "s": [200, 200],
                    "i": { "x": [1], "y": [1] },
                    "o": { "x": [0.42], "y": [0] },
                    "e": [200, 199.974]
                  },
                  {
                    "t": 33,
                    "s": [200, 199.974],
                    "i": { "x": [1], "y": [1] },
                    "o": { "x": [0.55], "y": [0.46] },
                    "e": [110, 110]
                  },
                  { "t": 40, "s": [110, 110] }
                ]
              },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "nm": "Object",
          "hd": false
        }
      ],
      "ln": "Full-Icon-Anim-Scaled"
    },
    {
      "ind": 2,
      "nm": "Layer 2",
      "ks": {
        "p": { "a": 0, "k": [0, 0] },
        "a": { "a": 0, "k": [0, 0, 0] },
        "s": { "a": 0, "k": [100, 100, 100] },
        "r": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ao": 0,
      "ip": 0,
      "op": 105,
      "st": 0,
      "bm": 0,
      "sr": 1,
      "ty": 4,
      "shapes": []
    },
    {
      "ind": 1,
      "nm": "Text Symbol",
      "ks": {
        "p": {
          "a": 1,
          "k": [
            {
              "t": 29,
              "s": [212.111, 377, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0],
              "i": { "x": [0.58], "y": [1] },
              "o": { "x": [0], "y": [0] },
              "e": [212.111, 367, 0]
            },
            { "t": 44, "s": [212.111, 367, 0] }
          ]
        },
        "a": { "a": 0, "k": [23.429, 5.709, 0] },
        "s": {
          "a": 1,
          "k": [
            {
              "t": 62,
              "s": [362.415, 362.416, 100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [362.415, 362.416, 100]
            },
            {
              "t": 70,
              "s": [362.415, 362.416, 100],
              "i": { "x": [0.745], "y": [0.715] },
              "o": { "x": [0.47], "y": [0] },
              "e": [29.192, 29.192, 100]
            },
            { "t": 76, "s": [29.192, 29.192, 100] }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "t": 34,
              "s": [0],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [100]
            },
            {
              "t": 35,
              "s": [100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [100]
            },
            {
              "t": 62,
              "s": [100],
              "i": { "x": [0.833], "y": [0.833] },
              "o": { "x": [0.167], "y": [0.167] },
              "e": [0]
            },
            { "t": 76, "s": [0] }
          ]
        }
      },
      "ao": 0,
      "ip": 0,
      "op": 105,
      "st": 0,
      "bm": 0,
      "sr": 1,
      "ty": 4,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-2.903, 0],
                        [0, -6.963],
                        [2.03, -2.322],
                        [3.549, 0],
                        [2.027, 2.9],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [1.797, -2.41],
                        [7.465, 0],
                        [0.045, 2.992],
                        [-2.258, 2.678],
                        [-3.549, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [0.428, 0.179],
                        [6.557, 0.179],
                        [6.557, 11.029],
                        [14.531, 7.635],
                        [27.344, 20.804],
                        [24.071, 29.822],
                        [14.716, 33.972],
                        [6.052, 29.822],
                        [6.052, 33.17],
                        [0.428, 33.17],
                        [0.428, 0.179]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-4.607, 0],
                        [0, 4.153],
                        [4.377, 0],
                        [0, -4.105],
                        [0, 0]
                      ],
                      "o": [
                        [0, 4.33],
                        [4.332, 0],
                        [0, -4.153],
                        [-4.102, -0.001],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.189, 20.492],
                        [13.885, 28.17],
                        [21.213, 20.849],
                        [13.885, 13.438],
                        [6.189, 20.49],
                        [6.189, 20.492]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 34.3,
                        "s": [11.89, 17.076],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [13.887, 17.076]
                      },
                      { "t": 35.7, "s": [13.887, 17.076] }
                    ]
                  },
                  "a": { "a": 0, "k": [13.887, 17.076] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 33,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      {
                        "t": 34.3,
                        "s": [100],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 35.7, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "B-2",
              "ln": "B-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [3.226, 0],
                        [2.212, 2.544],
                        [0, 3.438],
                        [-2.35, 2.588],
                        [-3.734, 0],
                        [-2.027, -2.768],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [-1.937, 2.544],
                        [-3.964, 0],
                        [-2.029, -2.367],
                        [0, -3.438],
                        [2.58, -2.902],
                        [3.501, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [56.197, 33.17],
                        [50.573, 33.17],
                        [50.573, 29.822],
                        [41.817, 33.972],
                        [32.414, 29.822],
                        [29.234, 20.804],
                        [32.505, 11.92],
                        [42, 7.635],
                        [50.571, 11.92],
                        [50.571, 8.438],
                        [56.194, 8.438],
                        [56.194, 33.168],
                        [56.197, 33.17]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -4.33],
                        [-4.147, 0.045],
                        [0, 4.24],
                        [4.332, -0.045]
                      ],
                      "o": [
                        [-4.518, -0.045],
                        [0, 4.061],
                        [4.425, 0.045],
                        [0, -4.24],
                        [0, 0]
                      ],
                      "v": [
                        [43.016, 13.44],
                        [35.365, 21.028],
                        [42.923, 28.17],
                        [50.388, 20.762],
                        [43.016, 13.44]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 33,
                        "s": [38.72, 23.8],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [42.715, 20.804]
                      },
                      { "t": 35.7, "s": [42.715, 20.804] }
                    ]
                  },
                  "a": { "a": 0, "k": [42.715, 20.804] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 33,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 34.3, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "A-2",
              "ln": "A-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [2.67, 2.586],
                        [-2.8, 2.713],
                        [-2.815, -2.456],
                        [0, 0],
                        [3.339, 0],
                        [2.63, -2.549],
                        [-5.263, -5.1],
                        [-5.278, 4.778],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [-2.813, 2.392],
                        [-2.8, -2.713],
                        [2.705, -2.624],
                        [0, 0],
                        [-2.595, -2.377],
                        [-3.338, 0],
                        [-5.263, 5.1],
                        [5.135, 4.975],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [77.381, 25.846],
                        [67.566, 25.54],
                        [67.566, 15.7],
                        [77.449, 15.448],
                        [81.921, 11.116],
                        [72.646, 7.551],
                        [63.099, 11.372],
                        [63.099, 29.867],
                        [81.856, 30.178],
                        [77.384, 25.846],
                        [77.381, 25.846]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 34.3,
                        "s": [67.54, 23.62],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [70.536, 20.616]
                      },
                      { "t": 37, "s": [70.536, 20.616] }
                    ]
                  },
                  "a": { "a": 0, "k": [70.536, 20.616] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 34.3,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 35.7, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "C-2",
              "ln": "C-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [84.096, 0.179],
                        [90.225, 0.179],
                        [90.225, 20.089],
                        [98.428, 8.438],
                        [105.663, 8.438],
                        [96.446, 20.535],
                        [107.185, 33.168],
                        [98.982, 33.168],
                        [90.225, 21.606],
                        [90.225, 33.168],
                        [84.096, 33.168],
                        [84.096, 0.179]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 35.7,
                        "s": [92.64, 19.67],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [95.64, 16.674]
                      },
                      { "t": 38.3, "s": [95.64, 16.674] }
                    ]
                  },
                  "a": { "a": 0, "k": [95.64, 16.674] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 35.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      {
                        "t": 38.3,
                        "s": [100],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 39.7, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "K-2",
              "ln": "K-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-5.16, 0],
                        [0, 0],
                        [0, 0],
                        [0.185, -2.723],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.138, -4.688],
                        [0, 0],
                        [0, 0],
                        [-2.536, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [109.63, 14.374],
                        [107.465, 14.374],
                        [107.465, 9.105],
                        [109.63, 9.105],
                        [117.971, 0.222],
                        [119.631, 0],
                        [119.631, 6.203],
                        [115.759, 9.105],
                        [119.308, 9.105],
                        [119.308, 14.374],
                        [115.759, 14.374],
                        [115.759, 33.315],
                        [109.63, 33.315],
                        [109.63, 14.374]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 37,
                        "s": [110.55, 19.66],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [113.548, 16.657]
                      },
                      { "t": 39.7, "s": [113.548, 16.657] }
                    ]
                  },
                  "a": { "a": 0, "k": [113.548, 16.657] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 37,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 38.3, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "F-2",
              "ln": "F-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [122.671, 0.179],
                        [128.8, 0.179],
                        [128.8, 33.17],
                        [122.671, 33.17],
                        [122.671, 0.179]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 38.3,
                        "s": [122.74, 19.67],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [125.736, 16.675]
                      },
                      { "t": 41, "s": [125.736, 16.675] }
                    ]
                  },
                  "a": { "a": 0, "k": [125.736, 16.675] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 38.3,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      {
                        "t": 41,
                        "s": [100],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      {
                        "t": 43.7,
                        "s": [100],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 45, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "L-2",
              "ln": "L-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "sh",
                      "d": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 1.84],
                            [1.899, 0],
                            [0, -1.84],
                            [-1.9, 0]
                          ],
                          "o": [
                            [1.899, 0],
                            [0, -1.84],
                            [-1.9, 0],
                            [0, 1.839],
                            [0, 0]
                          ],
                          "v": [
                            [136.128, 6.661],
                            [139.566, 3.331],
                            [136.128, 0],
                            [132.689, 3.331],
                            [136.128, 6.661]
                          ],
                          "c": true
                        },
                        "hd": false
                      }
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [1, 1, 1, 1] },
                      "hd": false,
                      "o": { "a": 0, "k": 100 },
                      "r": 1
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [3.438, 3.331] },
                      "a": { "a": 0, "k": [136.127, 3.331] },
                      "s": { "a": 0, "k": [100, 100] },
                      "r": { "a": 0, "k": 0 },
                      "o": { "a": 0, "k": 100 },
                      "sk": { "a": 0, "k": 0 },
                      "sa": { "a": 0, "k": 0 }
                    }
                  ],
                  "nm": "Object",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "sh",
                      "d": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [133.307, 8.44],
                            [139.436, 8.44],
                            [139.436, 33.17],
                            [133.307, 33.17],
                            [133.307, 8.44]
                          ],
                          "c": true
                        },
                        "hd": false
                      }
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [1, 1, 1, 1] },
                      "hd": false,
                      "o": { "a": 0, "k": 100 },
                      "r": 1
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [3.683, 20.805] },
                      "a": { "a": 0, "k": [136.372, 20.805] },
                      "s": { "a": 0, "k": [100, 100] },
                      "r": { "a": 0, "k": 0 },
                      "o": { "a": 0, "k": 100 },
                      "sk": { "a": 0, "k": 0 },
                      "sa": { "a": 0, "k": 0 }
                    }
                  ],
                  "nm": "Object",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 39.7,
                        "s": [133.13, 19.59],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [136.127, 16.585]
                      },
                      { "t": 42.3, "s": [136.127, 16.585] }
                    ]
                  },
                  "a": { "a": 0, "k": [3.439, 16.585] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 39.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      {
                        "t": 42.3,
                        "s": [100],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 43.7, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "I-2",
              "ln": "I-2",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-3.457, 0],
                        [-2.626, -2.857],
                        [0, -3.483],
                        [7.465, 0],
                        [2.072, 2.456],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [1.982, -2.723],
                        [3.733, 0],
                        [2.35, 2.366],
                        [0, 7.008],
                        [-3.226, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [143.698, 8.44],
                        [149.321, 8.44],
                        [149.321, 11.654],
                        [157.618, 7.635],
                        [166.88, 11.654],
                        [170.428, 20.804],
                        [157.615, 33.972],
                        [149.827, 30.49],
                        [149.827, 41.426],
                        [143.698, 41.426],
                        [143.698, 8.44]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "sh",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-1.66, -1.427],
                        [-1.705, 0],
                        [0, 4.15],
                        [4.147, 0],
                        [0, -4.108]
                      ],
                      "o": [
                        [0, 2.143],
                        [1.291, 1.116],
                        [4.332, 0],
                        [0, -3.929],
                        [-4.147, 0],
                        [0, 0]
                      ],
                      "v": [
                        [149.459, 20.806],
                        [151.857, 26.297],
                        [156.742, 28.17],
                        [164.3, 20.762],
                        [156.972, 13.44],
                        [149.459, 20.806]
                      ],
                      "c": true
                    },
                    "hd": false
                  }
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1] },
                  "hd": false,
                  "o": { "a": 0, "k": 100 },
                  "r": 1
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 1,
                    "k": [
                      {
                        "t": 41,
                        "s": [154.06, 27.53],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [157.063, 24.531]
                      },
                      { "t": 43.7, "s": [157.063, 24.531] }
                    ]
                  },
                  "a": { "a": 0, "k": [157.063, 24.531] },
                  "s": { "a": 0, "k": [100, 100] },
                  "r": { "a": 0, "k": 0 },
                  "o": {
                    "a": 1,
                    "k": [
                      {
                        "t": 31.7,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [0]
                      },
                      {
                        "t": 41,
                        "s": [0],
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "e": [100]
                      },
                      { "t": 42.3, "s": [100] }
                    ]
                  },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "nm": "P-2",
              "ln": "P-2",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [23.429, 5.709] },
              "a": { "a": 0, "k": [85.428, 20.713] },
              "s": { "a": 0, "k": [27.564, 27.564] },
              "r": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "nm": "Backflip Text-2",
          "ln": "Backflip-Text-2",
          "hd": false
        }
      ],
      "ln": "Text-Symbol"
    }
  ],
  "markers": []
}
